(function () {
  function parseTagValue(value) {
    return String(value || '')
      .split('+')
      .map(function (part) {
        return part.trim();
      })
      .filter(Boolean);
  }

  var COLLECTION_BY_TAG = {
    'col-capas': 'capas',
    'col-peliculas': 'peliculas',
    'col-visores': 'visores',
    'col-relogios': 'smartwatch',
    'col-cabos-carregadores': 'cabos-e-carregadores',
    'col-som': 'auriculares-sem-fios',
    'cat-auriculares-sem-fios': 'auriculares-sem-fios',
    'col-suportes': 'suportes',
    'col-acessorios': 'suportes',
    'col-outros': 'suportes',
    'col-informatica': 'suportes',
  };

  var FINDER_COLLECTION = {
    capas: 'capas',
    peliculas: 'peliculas',
    visores: 'visores',
    smartwatch: 'smartwatch',
    cabos: 'cabos-e-carregadores',
    som: 'auriculares-sem-fios',
    'auriculares-sem-fios': 'auriculares-sem-fios',
    suportes: 'suportes',
  };

  function buildSearchUrl(tags, meta) {
    var list = (tags || []).filter(Boolean);
    if (!list.length) return '';

    var colTag = null;
    var filterTags = [];
    list.forEach(function (tag) {
      if (tag.indexOf('col-') === 0) {
        colTag = tag;
      } else {
        filterTags.push(tag);
      }
    });

    var handle =
      (meta && meta.collectionHandle) ||
      (colTag && COLLECTION_BY_TAG[colTag]) ||
      (meta && meta.finder && FINDER_COLLECTION[meta.finder]) ||
      '';

    if (handle) {
      var params = new URLSearchParams();
      if (meta && meta.label) params.set('tek_label', meta.label);
      if (meta && meta.finder) params.set('tek_finder', meta.finder);
      var qs = params.toString();

      if (filterTags.length) {
        // Shopify: tags no path com "+" = AND (todos os tags obrigatórios).
        // filter.p.tag repetido = OR — devolve a coleção inteira.
        var path =
          '/collections/' +
          encodeURIComponent(handle) +
          '/' +
          filterTags
            .map(function (tag) {
              return encodeURIComponent(tag);
            })
            .join('+');
        return path + (qs ? '?' + qs : '');
      }

      return '/collections/' + encodeURIComponent(handle) + (qs ? '?' + qs : '');
    }

    var params = new URLSearchParams();
    params.set('type', 'product');
    params.set(
      'q',
      list
        .map(function (tag) {
          return 'tag:' + tag;
        })
        .join(' ')
    );
    if (meta && meta.label) params.set('tek_label', meta.label);
    if (meta && meta.finder) params.set('tek_finder', meta.finder);
    return '/search?' + params.toString();
  }

  function readUrlLabel() {
    try {
      return new URLSearchParams(window.location.search).get('tek_label') || '';
    } catch (e) {
      return '';
    }
  }

  window.TekFinder = {
    parseTagValue: parseTagValue,
    buildSearchUrl: buildSearchUrl,
    readUrlLabel: readUrlLabel,
  };
})();
